import { render, staticRenderFns } from "./LowVehicleValueWarning.vue?vue&type=template&id=e6840128&"
import script from "./LowVehicleValueWarning.vue?vue&type=script&lang=js&"
export * from "./LowVehicleValueWarning.vue?vue&type=script&lang=js&"
import style0 from "./LowVehicleValueWarning.vue?vue&type=style&index=0&id=e6840128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports